document.querySelectorAll('.column__image:nth-child(2)').forEach((target) => {
  target.insertAdjacentHTML('afterbegin', `
    <div class="lineGraphCont line-out">
      <div class="triangle"></div>
      <div class="line"></div>
    </div>
  `);
});


document.querySelectorAll('.column__content').forEach(item => {
  const line = item.querySelector('.lineGraphCont');
  const image = item.querySelector('.column__image:first-child');
  const innerImage = item.querySelector('.column__image:nth-child(2)');

  item.addEventListener('mouseenter', () => {

    // First image moves UP 25px
    image?.classList.add('imageHover');

    // Second image fades 0.5 → 1
    innerImage?.classList.add('fade-in');
    innerImage?.classList.remove('fade-out');

    // Triangle + line fades 0 → 1
    line?.classList.add('line-in');
    line?.classList.remove('line-out');

  });

  item.addEventListener('mouseleave', () => {

    // First image returns
    image?.classList.remove('imageHover');

    // Second image fades 1 → 0.5
    innerImage?.classList.add('fade-out');
    innerImage?.classList.remove('fade-in');

    // Triangle + line fades 1 → 0
    line?.classList.add('line-out');
    line?.classList.remove('line-in');

  });
});
const element = document.querySelector('.shopify-section:nth-child(2) .page-width.page-width--full.relative');

if (element) {
  element.id = 'learn-more';
}
(function () {
    document.querySelector('a.button.button--primary.button--sm.size-style:last-child').addEventListener('click', function (e) {
        e.preventDefault();

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        this.blur();

        document.querySelector('.topbar__left-shipping.flex.items-center.gap-2')?.focus();
    });
})();